import {
  AssessmentDeliveryFragment,
  AssessmentDeliveryTemplateFragment,
} from "types/graphql-schema";

import AssessmentDeliveryCalibrationChangelog from "../calibration/assessment-delivery-calibration-changelog";
import AssessmentLayout from "../layouts/assessment-layout";
import { DeliveryData } from "./assessment-delivery";
import AssessmentDeliveryContent from "./assessment-delivery-content";

const AssessmentDeliveryStack = ({
  assessmentTemplate,
  assessmentDeliveryData,
  isShowingHiddenQuestions,
  title,
  shouldHaveData,
  isDraft,
  canUpdate,
  excludedAnswerIds,
  onUpdateDeliveryData,
}: {
  assessmentTemplate?: AssessmentDeliveryTemplateFragment | null;
  assessmentDeliveryData?: AssessmentDeliveryFragment;
  shouldHaveData: boolean;
  isShowingHiddenQuestions: boolean;
  title: string;
  isSaving?: boolean;
  canUpdate: boolean;
  isDraft: boolean;
  excludedAnswerIds: number[];
  onUpdateDeliveryData: (data: Partial<DeliveryData>) => void;
}) => {
  if (!assessmentTemplate || (!assessmentDeliveryData && !shouldHaveData)) {
    return null;
  }
  if (!assessmentDeliveryData) {
    return (
      <AssessmentLayout.AssessmentTypeSection>
        <AssessmentLayout.AssessmentTypeHeader
          id={`container-assessment-type-${assessmentTemplate.assessmentType}`}
        >
          {title}
        </AssessmentLayout.AssessmentTypeHeader>
        <AssessmentLayout.ResponsesNotAvailable>
          Responses are not available yet. Please check back later.
        </AssessmentLayout.ResponsesNotAvailable>
      </AssessmentLayout.AssessmentTypeSection>
    );
  }

  const content = AssessmentDeliveryContent({
    assessmentTemplate,
    assessmentDeliveryData,
    canUpdate,
    isDraft,
    excludedAnswerIds,
    onUpdateDeliveryData,
    showHiddenQuestions: isShowingHiddenQuestions,
  });

  return content ? (
    <AssessmentLayout.AssessmentTypeSection>
      <div className="flex gap-6 items-center">
        <AssessmentLayout.AssessmentTypeHeader
          id={`container-assessment-type-${assessmentTemplate.assessmentType}`}
        >
          {title}
        </AssessmentLayout.AssessmentTypeHeader>
      </div>

      {isShowingHiddenQuestions && (
        <AssessmentDeliveryCalibrationChangelog
          assessmentTemplateId={assessmentTemplate.id}
          calibration={assessmentDeliveryData.complianceProgram?.calibration}
          complianceProgramId={assessmentDeliveryData.complianceProgram?.id}
          targetId={assessmentDeliveryData.target?.id}
        />
      )}

      <div className="mt-12">{content}</div>
    </AssessmentLayout.AssessmentTypeSection>
  ) : null;
};

export default AssessmentDeliveryStack;
